import * as React from "react";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../ui/navbar/logo.png";

export default function PrivacyPolicy() {
  return (
    <Container style={{ maxWidth: 800, paddingTop: 60, paddingBottom: 60 }}>
      <Row>
        <Col>
          <div style={{ marginBottom: 32 }}>
            <img src={logo} width={80} height={68} alt="EA1 Roadside Assistance" />
          </div>
          <h1>Privacy Policy</h1>
          <p className="text-muted">Last updated: May 26, 2026</p>

          <p>
            EA1 Roadside Assistance ("we," "our," or "us") is committed to
            protecting your privacy. This Privacy Policy explains how we
            collect, use, and safeguard your personal information when you use
            our mobile applications and services.
          </p>

          <h5>Information We Collect</h5>
          <p>
            We collect information you provide directly, including your name,
            email address, phone number, vehicle details, and emergency contact
            information. When you request or fulfill a roadside assistance
            service, we also collect your location data to connect requesters
            with nearby providers.
          </p>

          <h5>How We Use Your Information</h5>
          <p>
            We use your information to process and fulfill roadside assistance
            requests, connect requesters with service providers in their area,
            send real-time notifications about service status, process payments
            through Stripe, and improve the overall app experience.
          </p>

          <h5>Location Data</h5>
          <p>
            Our apps require access to your device's location to dispatch
            roadside assistance providers to requesters and to help providers
            find nearby service requests. Location data is only collected while
            the app is active and in use. We do not track your location in the
            background.
          </p>

          <h5>Data Sharing</h5>
          <p>
            We share your information only between requesters and the service
            providers matched to their requests. We do not sell your personal
            data to third parties. We may disclose information if required by
            law or to protect the safety of our users.
          </p>

          <h5>Data Security</h5>
          <p>
            We implement industry-standard security measures to protect your
            personal information from unauthorized access, alteration, or
            disclosure. All data is transmitted using encryption.
          </p>

          <h5>Your Rights</h5>
          <p>
            You may request access to, correction of, or deletion of your
            personal information at any time by contacting our support team.
            You can also deactivate your account directly from within the app.
          </p>

          <h5>Contact Us</h5>
          <p>
            If you have questions about this Privacy Policy, please contact us
            at{" "}
            <a href="mailto:admin.support@ecare-software.com">
              admin.support@ecare-software.com
            </a>
            . We will respond to all privacy-related inquiries within 30 days.
          </p>
        </Col>
      </Row>
    </Container>
  );
}
